// extracted by mini-css-extract-plugin
export default {"row":"DetailRow_row__X4vJs"};